<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import HeroSideBySide from './heroSideBySide.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: ISbRichtext;
			headline_style: 'bold' | 'regular';
			subheadline: ISbRichtext;
			buttons: ISbStoryData[];
			fullscreen_video: ISbStoryData['content'];
			fullscreen_button_label: string;
			background_asset_mobile: ISbStoryData[];
			background_asset_desktop: ISbStoryData[];
			press_banner: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<HeroSideBySide
	content={{
		...content,
		background_color: 'white',
		text_alignment_desktop: 'left-bottom',
		text_alignment_mobile: 'bottom'
	}}
/>
